'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountMerge = accountMerge;

var _stellarXdr_generated = require('../generated/stellar-xdr_generated');

var _stellarXdr_generated2 = _interopRequireDefault(_stellarXdr_generated);

var _decode_encode_muxed_account = require('../util/decode_encode_muxed_account');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Transfers native balance to destination account.
 *
 * @function
 * @alias Operation.accountMerge
 *
 * @param {object} opts - options object
 * @param {string} opts.destination - destination to merge the source account into
 * @param {bool}  [opts.withMuxing] - indicates that opts.destination is an
 *     M... address and should be interpreted fully as a muxed account. By
 *     default, this option is disabled until muxed accounts are mature.*
 * @param {string} [opts.source]    - operation source account (defaults to
 *     transaction source)
 * @returns {xdr.Operation} an Account Merge operation (xdr.AccountMergeOp)
 */


function accountMerge(opts) {
  var opAttributes = {};

  try {
    opAttributes.body = _stellarXdr_generated2.default.OperationBody.accountMerge((0, _decode_encode_muxed_account.decodeAddressToMuxedAccount)(opts.destination, opts.withMuxing));
  } catch (e) {
    throw new Error('destination is invalid');
  }

  this.setSourceAccount(opAttributes, opts);
  return new _stellarXdr_generated2.default.Operation(opAttributes);
}